import styled from "styled-components";

export const H2 = styled.h2`
  color: #b8a06a;
  padding: 15px 0px !important;
`;
